import { render } from "./HolidayForm.vue?vue&type=template&id=f8d3c56e&scoped=true&ts=true"
import script from "./HolidayForm.ts?vue&type=script&lang=ts"
export * from "./HolidayForm.ts?vue&type=script&lang=ts"

import "./HolidayForm.scss?vue&type=style&index=0&id=f8d3c56e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8d3c56e"]])

export default __exports__